import styled from 'styled-components/native';

export const FOHMessageIconView = styled.View`
  background-color: 'transparent';
  margin-right: 4px;
  justify-content: center;
  align-items: center;
`;
